import { Box } from '@hivebrite/design-system/Box';
import { Card } from '@hivebrite/design-system/Card';
import { Skeleton } from '@hivebrite/design-system/Skeleton';

const MentorCardLoader = () => (
  <Card height={{ _: 200 }} p={4}>
    <Box mb={4}>
      <Skeleton height={60} width={60} mr={3} css="border-radius: 50%;" />
      <Box display="block" width="100%" mt="10px" css="flex: 1 1 0%;">
        <Skeleton height={20} mb={1} width="100%" />
        <Skeleton height={17} width="60%" />
      </Box>
    </Box>

    <Skeleton height={15} mb={2} width="100%" />
    <Skeleton height={15} mb={2} width="70%" />
    <Skeleton height={15} mb={2} width="40%" />
    <Skeleton height={15} width="60%" />
  </Card>
);
export default MentorCardLoader;
